// @ts-strict-ignore
import { FC } from 'react'

import { FormPreloader } from '@/screensComponents/Form/FormPreloader/FormPreloader'
import { FormProps } from '@/screensComponents/Form/types'

import { SettingsIPort, StatusOkIPort } from '@/shared/lib/@deprecated/iport-icons'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import cl from './FormStatus.module.scss'

export const FormStatus: FC<
	{
		isSuccess?: boolean
		isLoading?: boolean
		isError?: boolean
	} & { onSuccessContent: FormProps['onSuccessContent'] }
> = ({ isSuccess, isLoading, isError, onSuccessContent }) => {
	if (isSuccess) {
		return (
			<div className={cl.formStatus}>
				<div className={cl.iconWrapper}>
					<StatusOkIPort height={48} width={48} viewBox={'0 0 48 48'} className={cl.formStatus__icon} />
				</div>
				<div className={cl.formStatus__textWrapper}>
					{onSuccessContent?.title && (
						<h2 className={cl.formStatus__title} dangerouslySetInnerHTML={createMarkup(onSuccessContent.title)} />
					)}
					{!onSuccessContent?.title && (
						<h2 className={cl.formStatus__title}>
							{onSuccessContent?.title ? onSuccessContent.title : 'Ваша заявка отправлена'}
						</h2>
					)}
					{onSuccessContent?.subtitle && (
						<p className={cl.formStatus__subtitle} dangerouslySetInnerHTML={createMarkup(onSuccessContent.subtitle)} />
					)}
					{!onSuccessContent?.subtitle && (
						<p className={cl.formStatus__subtitle}>В течение одного рабочего дня менеджер компании свяжется с вами</p>
					)}
				</div>
			</div>
		)
	}
	if (isLoading) {
		return (
			<div className={cl.formPreloader}>
				<FormPreloader />
			</div>
		)
	}
	if (isError) {
		return (
			<div className={cl.formStatus}>
				<div className={cl.formStatus__contentWrapper}>
					<div className={cl.iconWrapper}>
						<SettingsIPort height={48} width={48} viewBox={'0 0 48 48'} className={cl.formStatus__icon} />
					</div>
					<div className={cl.formStatus__textWrapper}>
						<h2 className={cl.formStatus__title}>Произошла ошибка</h2>
						<p className={cl.formStatus__subtitle}>Попробуйте позже</p>
					</div>
				</div>
			</div>
		)
	}
}
